// src/data/mangoData.js
export const mangoCategories = [
    {
        id: 1,
        name: "Amrapali",
        description: "Juicy and fiberless, rich mango flavor",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1782286841/WhatsApp_Image_2026-06-19_at_22.13.24_1_xnnjke.jpg",
        origin: "Chapainawabganj",
        variants: [
            { weight: "12kg", price: 1440 },
            { weight: "20kg", price: 2400 },
            { weight: "40kg", price: 4800 }
        ]
    },
    {
        id: 2,
        name: "Banana Mango",
        description: "Sweet and aromatic, perfect for desserts",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1782286815/WhatsApp_Image_2026-06-19_at_22.11.30_mkm6sa.jpg",
        origin: "Rajshahi",
        variants: [
            { weight: "12kg", price: 1680 },
            { weight: "20kg", price: 2800 },
            { weight: "40kg", price: 5600 }
        ]
    },

    {
        id: 3,
        name: "Bari 4",
        description: "Famous for its unique sweet taste and aroma",
        image: "https://res.cloudinary.com/do3soodbc/image/upload/v1782286829/WhatsApp_Image_2026-06-19_at_22.11.58_bh4cqv.jpg",
        origin: "Rajshahi",
        variants: [
            { weight: "12kg", price: 1320 },
            { weight: "20kg", price: 2200 },
            { weight: "40kg", price: 4400 }
        ]
    }
];

export const mangoHeroSlides = [
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.16_2_m5pq41.jpg",
        headline: "🍋 Sweet Summer Mangoes!",
        subheadline: "Fresh, Juicy & Directly from the Farm",
        primaryBtn: "Order Now",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.17_1_jfzdvi.jpg",
        headline: "🥭 Premium Quality Mangoes",
        subheadline: "Himshagor, Amrapali, Fazli & More",
        primaryBtn: "Explore Mangoes",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.18_ceut15.jpg",
        headline: "🎁 Bulk Order Available!",
        subheadline: "Perfect for Gifts, Events & Family",
        primaryBtn: "Order in Bulk",
        category: "All"
    }
];